import Clubreg from './modules/clubreg';
$(function () {
    window.Clubreg = new Clubreg();
});
